import { BaseIcon } from 'src/components/BaseIcon';
import { InfoHelper } from '../InfoHelper';
import React from 'react';
import { TAssetBlockProps } from './AssetBlock.types';
import classnames from 'classnames';
import s from './AssetBlock.module.scss';

export const AssetBlock: React.FC<TAssetBlockProps> = ({
  className,
  icon,
  title,
  subtitle,
  description,
  theme = 'dark',
  aspectRatio = 107,
  onClick,
  onThreeDotsClick,
  topLeftComponent,
  bottomRightComponent,
  isCustomPV,
  chartAssetClass,
}: TAssetBlockProps) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const MainComponent: any = onClick ? 'button' : 'div';

  return (
    <div className={`${className} ${s.container} ${s[`theme-${theme}`]}`}>
      {topLeftComponent && <div className={s.topLeftComponent}>{topLeftComponent}</div>}

      <div className={`${s.blockOuter}`} style={{ paddingTop: aspectRatio + '%' }}>
        <MainComponent
          className={classnames(s.block, chartAssetClass)}
          type="button"
          onClick={onClick}>
          <BaseIcon className={s.mainIcon} icon={icon} />

          <div className={s.detailsSize}>
            <h3 className={s.title}>{title}</h3>
            <p className={s.subtitle}>{subtitle}</p>
          </div>
        </MainComponent>

        {/* <button type="button" className={s.dragButton}>
        <BaseIcon className={s.dragIcon} icon="drag" />
      </button> */}

        {onThreeDotsClick && (
          <button onClick={onThreeDotsClick} type="button" className={s.threeDots}>
            <BaseIcon icon="more-horizontal" size={10} />
          </button>
        )}

        {isCustomPV && (
          <div className={s.rightIcon}>
            <BaseIcon icon="star" size={10} />
          </div>
        )}

        {description && <InfoHelper className={s.infoButton} size={8} info={description} />}
        {bottomRightComponent && <div className={s.bottomRight}>{bottomRightComponent}</div>}
      </div>
    </div>
  );
};
